import styled from 'styled-components';

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
	gap: 24px;
	width: 100%;

	@media (max-width: 768px) {
		gap: 16px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	}
`;

export const CategoryCard = styled.div`
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	cursor: pointer;
	position: relative;
	display: flex;
	flex-direction: column;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
	}
`;

export const CategoryTitle = styled.h3`
	margin: 0;
	padding: 16px;
	font-size: 1.2rem;
	text-align: center;
	background-color: white;
	color: var(--color-text-primary, #333);
	text-transform: capitalize;
`;
